import { gql } from '@apollo/client/core';

export const UNPAUSE_SUBSCRIPTION_MUTATION = gql`
  mutation unpauseSubscription($input: UnpauseSubscriptionInput!) {
    unpauseSubscription(input: $input) {
      errors {
        message
        type
      }
    }
  }
`;
